import axios from 'axios'
import { useMutation, useQueryClient } from 'react-query'

export const useUser = () => {
    const queryClient = useQueryClient()

    return useMutation((body: any) => axios.put(`usersetup`, body), {
        onSuccess: () => {
            queryClient.invalidateQueries(['users'])
        }
    })
}

